export default __webpack_public_path__ + "static/media/dribbble_1.46e5372c.gif";